import { patchState, signalStore, withMethods, withState } from '@ngrx/signals';

export type BrandingState = {
  logoUrl: string | null;
  brandColor: string | null;
  isLoaded: boolean;
};

const initialState: BrandingState = {
  logoUrl: null,
  brandColor: null,
  isLoaded: false,
};

export const BrandingStore = signalStore(
  { providedIn: 'root' },
  withState(initialState),
  withMethods((store) => ({
    setBranding: (branding: { logoUrl: string | null; brandColor: string | null }) =>
      patchState(store, { ...branding, isLoaded: true }),
    reset: () => patchState(store, initialState),
  }))
);
